
import { uomLookup } from 'shared/product/product-lookups';
import { SegmentFieldItem } from 'utils/segment-field-item.interface';


/* eslint-disable */
export const kitsSegmentData: Array<SegmentFieldItem> = [
  {
    'field_map': 'componentBrand',
    'item_name': 'component_brand',
    'title': 'Brand',
    'hint_detail': 'Brand that manufactures this kit component.',
    'hint_panel' : 'Select Brand that manufactures this kit component.',
    'example': 'ABC Aftermarket Company',
    'sequence': null,
    'show_more': true,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 60,
        message: 'Brand cannot be longer than 60 characters.'
      }
    },
    'lookup': null,
  },
  {
    'field_map': 'componentBrandLabel',
    'item_name': 'component_brand_label',
    'title': 'Brand',
    'hint_detail': 'Brand that manufactures this kit component.',
    'hint_panel' : 'Select Brand that manufactures this kit component.',
    'example': 'RxSpeed',
    'sequence': null,
    'show_more': true,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 60,
        message: 'Brand cannot be longer than 60 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'componentSubBrandLabel',
    'item_name': 'component_sub_brand_label',
    'title': 'Component SubBrand Label',
    'hint_detail': 'SubBrand that manufactures this kit component.',
    'hint_panel' : 'Select SubBrand that manufactures this kit component.',
    'example': 'RxSpeed',
    'sequence': null,
    'show_more': true,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 60,
        message: 'SubBrand cannot be longer than 60 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'componentSubBrand',
    'item_name': 'component_sub_brand',
    'title': 'Component SubBrand',
    'hint_detail': 'SubBrand that manufactures this kit component.',
    'hint_panel' : 'Select SubBrand that manufactures this kit component.',
    'example': 'RxSpeed',
    'sequence': null,
    'show_more': true,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 60,
        message: 'SubBrand cannot be longer than 60 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'partTerminologyId',
    'item_name': 'part_terminology_id',
    'title': 'Part terminology ID',
    'hint_detail': '',
    'hint_panel' : 'The terminology for the part',
    'example': 'ABC1234',
    'sequence': null,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'partType',
    'item_name': 'part_type',
    'title': 'Part Terminology',
    'hint_detail': '',
    'hint_panel' : 'The part terminology name',
    'example': '',
    'sequence': null,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'componentPartNumber',
    'item_name': 'component_part_number.value',
    'title': 'Part No.',
    'hint_detail': 'Part number of this component.',
    'hint_panel' : 'Select an existing part number, or enter a new part number to create a new item. ',
    'example': 'Multiple components make up a kit, each component must be an existing item number in your catalog but doesn\'t necessarily need to be available for sale (Not Orderable)',
    'sequence': 1,
    'show_more': true,
    'lookup': null,
    'api_lookup': {
      'type': 'typeahead',
      'field_map': 'componentPartNumber',
      'item_name': 'partNumber',
      'lookup': 'partNumber',
    }
  },
  {
    'field_map': 'componentIdQualifier',
    'item_name': 'component_part_number.id_qualifier',
    'title': 'Component ID Qualifier',
    'hint_detail': 'Component ID Qualifier of this component.',
    'hint_panel' : 'Enter an ID Qualifier.',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'lookup': [
      {
        'title': "Vendor's (Seller's) Catalog Number",
        'option': 'VC'
      },
      {
        'title': "Vendor's (Seller's) Supplemental Item Number",
        'option': 'VS'
      },
      {
        'title': "Vendor's (Seller's) Part Number",
        'option': 'VP'
      },
      {
        'title': "Vendor's (Seller's) Item Number",
        'option': 'VN'
      }
    ],
    'validation': {
      'pies65' : {
        length: 2,
        message: 'Component ID Qualifier is required and should be 2 characters'
      }
    },
  },
  {
    'field_map': 'description',
    'item_name': 'description.value',
    'title': 'Description',
    'hint_detail': 'Describes the product.',
    'hint_panel' : 'Up to 20 characters briefly describing product.',
    'example': 'Cold Air Intake Kit',
    'sequence': 2,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'descriptionLanguage',
    'item_name': 'description.language',
    'title': 'Language',
    'hint_detail': '',
    'hint_panel' : 'Select the language of the description',
    'example': '',
    'sequence': null,
    'show_more': true,
    'lookup': null,
  },
  {
    'field_map': 'descriptionType',
    'item_name': 'description.type',
    'title': 'Description type',
    'hint_detail': '',
    'hint_panel' : 'Select the description type',
    'example': '',
    'sequence': null,
    'show_more': true,
    'lookup': null,
  },
  {
    'field_map': 'quantityInKit',
    'item_name': 'quantity_in_kit.quantity',
    'title': 'Quantity',
    'hint_detail': 'Quantity in kit',
    'hint_panel' : 'Enter the quantity of these components in this kit.',
    'example': '1',
    'sequence': 3,
    'show_more': true,
    'numerical': true,
    'lookup': null,
    'validation': {
      'pies65' : {
        required: true,
        min: 1,
        max: 99999999,
        message: 'Quantity in kit is required and cannot be greater than 99999999',
      }
    }
  },
  {
    'field_map': 'quantityInKitUom',
    'item_name': 'quantity_in_kit.uom',
    'title': 'Quantity unit of measure',
    'hint_detail': '',
    'hint_panel' : 'Units of measure for the packaged component in this kit.',
    'example': 'Ounces',
    'sequence': 4,
    'show_more': true,
    'validation': {
      'pies65' : {
        required: true,
        minLength: 1,
        maxLength: 4,
        message: 'Units of measure are required and may not be longer than 4 characters',
      }
    },
    'lookup': uomLookup,
  },
  {
    'field_map': 'soldSeparately',
    'item_name': 'sold_separately',
    'title': 'Sold separately',
    'hint_detail': 'Sold separately',
    'hint_panel' : 'Sold separately',
    'example': '',
    'sequence': 5,
    'show_more': true,
    'lookup': [
      {
        'option': 'Y',
        'title': 'Yes'
      },
      {
        'option': 'N',
        'title': 'No'
      }
    ]
  },
];
/* eslint-enable */
